import { Middleware } from '@nuxt/types';
import { Logger } from '~/helpers/logger';
import { redirectToFallback } from '~/helpers/notFoundFallback';

const CLINIC_EXISTS_QUERY = `
query clinicExists($url: String) {
  clinics(url: $url) {
    items {
      url
    }
  }
}
`;

interface ClinicExistsQuery {
  clinics?: { items?: { url?: string }[] };
}

/**
 * /mottagning/:slug - sends unknown clinics to the closest generic page instead of a 404.
 *
 * The clinics query falls back to returning every clinic when the url matches nothing,
 * so the returned url has to be compared with the requested one.
 */
const clinicMiddleware: Middleware = async (context) => {
  const slug = String(context.route.params.slug ?? '').toLowerCase();

  const { data: rawData, errors } = await context.app.$vsf.$magento.api.customQuery({
    query: CLINIC_EXISTS_QUERY,
    queryVariables: { url: slug },
  });

  const data = rawData as ClinicExistsQuery | undefined;

  Logger.debug('middleware/clinic/result', { data, errors });

  const items = data?.clinics?.items ?? [];
  const exists = items.some((item) => String(item?.url ?? '').toLowerCase() === slug);

  if (errors?.length || !exists) redirectToFallback(context);
};

export default clinicMiddleware;
